/**
 * @todo Use `{{> @partial-block }}` after upgrading to Handlebars v4.
 * That will get rid of the need for this file.
 */
import type {
    HandlebarsHelperOptions,
    TypeSafeTemplateDelegate,
} from '../../../Utility/Handlebars/types';
import announcementCompiled from './announcementBlock.hbs';
import type { BaseContext } from './types';

const announcementHelper: TypeSafeTemplateDelegate<BaseContext> = function (context, options) {
    return announcementCompiled({
        ...context,
        html: (options as HandlebarsHelperOptions).fn(this),
    });
};

export default announcementHelper;
